import { useAtomValue, useSetAtom } from 'jotai';
import { AssignmentResponse } from '@/types';
import { Badge } from '../../ui/badge';

import {
  assignmentConversationsAtom,
  assignmentDraftsAtom,
  fetchAssignmentConversationsActionAtom,
  fetchDraftsActionAtom,
} from '@/stores/assignmentsStore';
import { TranscriptsBlock } from './TranscriptsBlock';
import { DraftWorkflowBlock } from './DraftWorkflowBlock';
import { useEffect } from 'react';

export interface PostInterviewWorkflowProps {
  assignment: AssignmentResponse;
  isDetailsPage?: boolean;
}

export const PostInterviewWorkflow = ({
  assignment,
  isDetailsPage = false,
}: PostInterviewWorkflowProps) => {
  const fetchAssignmentConversations = useSetAtom(
    fetchAssignmentConversationsActionAtom
  );

  const conversations =
    useAtomValue(assignmentConversationsAtom)[assignment.id] || [];
  const drafts = useAtomValue(assignmentDraftsAtom)[assignment.id] || [];

  const handleFetchConversations = async () => {
    await fetchAssignmentConversations(assignment.id);
  };

  const fetchDrafts = useSetAtom(fetchDraftsActionAtom);

  const handleFetchDrafts = async () => {
    await fetchDrafts(assignment.id);
  };

  useEffect(() => {
    if (drafts.length === 0) {
      handleFetchDrafts();
    }
  }, [drafts.length]);

  useEffect(() => {
    if (conversations.length === 0) {
      handleFetchConversations();
    }
  }, [conversations.length]);

  const postStepsCompleted = [
    conversations.length > 0 && 'Transcript',
    drafts.length > 0 && 'Draft',
  ].filter(Boolean).length;

  if (conversations.length === 0 && drafts.length === 0) {
    return null;
  }

  return (
    <div className='space-y-3 !mt-8'>
      <div className='flex items-center justify-between'>
        <h4 className='text-sm font-medium'>Post-Interview Workflow</h4>
        <Badge variant='outline' className='text-xs'>
          {postStepsCompleted}/2 Complete
        </Badge>
      </div>

      <TranscriptsBlock assignment={assignment} isDetailsPage={isDetailsPage} />
      <DraftWorkflowBlock
        assignment={assignment}
        isDetailsPage={isDetailsPage}
      />
    </div>
  );
};
